module.exports = __webpack_public_path__ + "assets/img/icon1.c0bf1fda.svg";